import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const wizardNavigation: ThemedFunctor = () => css`
  > *:first-child{
    flex-grow: 1;
  }

  > *:last-child{
    flex-shrink: 0;
  }
`;

export const erroredStepListItem: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLEST)}
  ${getSpacing.padding(theme, SpacingName.SMALLER)}
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid transparent;
  background-color: ${theme.palettes.neutrals.lighter};

  &:hover {
    background-color: ${theme.palettes.status.alertLighter};
    border-color: ${theme.palettes.status.alertLight};
    color: ${theme.palettes.status.alert};
  }
`;
